var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeatherInterior32 = function SvgLeatherInterior32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.979 1s-.067 6.012 6.227 5.35L23 9.853s-6.51 5.331 0 12.039l-1.794 3.003s-6.124-1.74-9.18 4.105h-.053c-3.06-5.844-9.179-4.105-9.179-4.105L1 21.892c6.51-6.708 0-12.04 0-12.04L2.794 6.35C9.075 7.012 9.021 1 9.021 1h5.958Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLeatherInterior32;